export default __webpack_public_path__ + "fe5baf2a53b097c8605dd4002e703229.png";